import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UserState {
  id: number | null;
  name: string;
  email: string;
  mobile_phone: string;
  error: string | null;
  isDigital: boolean | null;
  termsAndConditions: boolean | null;
  cookieConsent: boolean | null;
  impersonating: boolean | false;
}

export const initialState: UserState = {
  id: null,
  name: '',
  email: '',
  mobile_phone: '',
  error: null,
  impersonating: false,
  isDigital: null,
  termsAndConditions: null,
  cookieConsent: null
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    fetchUserFailure: (state, action: PayloadAction<any>) => {
      state.error = action.payload;
    },
    setUserId: (state, action: PayloadAction<any>) => {
      const { id, terms_and_conditions, cookie_consent } = action.payload;
      state.id = id;
      state.termsAndConditions = terms_and_conditions;
      state.cookieConsent = cookie_consent ?? null;
    },
    setUserInfo: (state, action: PayloadAction<any>) => {
      const { name, email, mobile_phone } = action.payload;
      state.email = email;
      state.name = name;
      state.mobile_phone = mobile_phone;
    },
    setUserDigital: (state, action: PayloadAction<any>) => {
      state.isDigital = action.payload;
    },
    setImpersonating: (state, action: PayloadAction<any>) => {
      state.impersonating = action.payload > 0;
    },
    updateUserSuccess: (state, action: PayloadAction<any>) => {
      const { name, email, mobile_phone } = action.payload;
      state.name = name;
      state.email = email;
      state.mobile_phone = mobile_phone;
    },
    updateUserFailure: (state, action: PayloadAction<any>) => {
      state.error = action.payload;
    },
    setCookieConsent: (state, action: PayloadAction<boolean | null>) => {
      state.cookieConsent = action.payload;
    },
    updateUserMeSuccess: (state, action: PayloadAction<any>) => {
      const { terms_and_conditions, cookie_consent } = action.payload;
      state.termsAndConditions = terms_and_conditions;
      state.cookieConsent = cookie_consent ?? null;
    },
    updateUserMeFailure: (state, action: PayloadAction<any>) => {
      state.error = action.payload;
    },
    resetUserInfo: () => initialState
  }
});

export const {
  fetchUserFailure,
  setUserId,
  setUserInfo,
  setUserDigital,
  setImpersonating,
  resetUserInfo,
  setCookieConsent,
  updateUserMeSuccess,
  updateUserMeFailure,
  updateUserSuccess,
  updateUserFailure
} = userSlice.actions;

export default userSlice.reducer;
